export default __webpack_public_path__ + "static/media/warning-fill.86824910.svg";